import React, { Fragment, useEffect, useState } from "react";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import { User } from "react-feather";
import { withRouter } from "react-router-dom";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import { toast } from "react-toastify"; // ToastContainer,
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
//import { yupResolver } from "@hookform/resolvers"
import { yupLoginValidation } from "../../utils/authValidation";
import { withoutAuth } from "../../config/axios";
import axios from "axios";
import { serverPath } from "../../config/keys";
import Popup2FA from "../settings/TwoFa/popup2FA";
import Reset from "../settings/TwoFa/resetPopup";
import Revocation from "../settings/TwoFa/revocation";
import { queryString } from "../../utils/queryString";
import { useHistory } from "react-router-dom";
const LoginTabset = () => {
  const history = useHistory();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(yupLoginValidation()),
  });
  const [twoFactorData, setTwoFactorData] = useState({});
  const [displayData, setDisplayData] = useState({});
  const [open, setOpen] = useState(false);
  const [adminToken, setAdminToken] = useState("");
  const [lostLine, setLostLine] = useState(false);
  const [emailSending, setEmailSending] = useState(false);
  const [revokeToken, setRevokeToken] = useState("");
  const [showRevocation, setRevocation] = useState(false);
  const [revocationLoading, setRevocationLoading] = useState(false);
  const { revoke } = queryString();

  const handleClose = () => {
    setTwoFactorData({});
    setDisplayData({});
    setOpen(false);
  };

  useEffect(() => {
    if (revoke) {
      setRevokeToken(revoke);
      setRevocation(true);
    }
  }, [revoke]);

  const checkTwoFAEnable = async (token) => {
    const response = await axios.get(
      `${serverPath}/api/admin/checkTwoFAEnable`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    if (response?.data.code === 200) {
      setTwoFactorData({
        twoFactorAuthEnabled: response?.data?.twoFactorAuthEnabled,
      });

      if (response?.data?.twoFactorAuthEnabled) {
        setDisplayData({
          header: "Verify Account",
          title: "Two-Factor Authentication",
          desc: "This account is protected by Two-Factor Authentication. Please enter the code below to continue.",
          tagLine: "Enter 2FA Code",
          btnText: "CONTINUE",
          btnColor: "#66852f",
          btnTextColor: "#ddf2b8",
          nextBtnText: "Cancel",
          lostline: "Lost access to your authenticator ?",
        });
        setAdminToken(token);
        setOpen(true);
      } else {
        toast.success("Login Successful", { toastId: "success-message-2fa-login" });
        localStorage.setItem("ad@#t", token);
        window.location.href = "/dashboard";
      }
    }
  };

  const verifyTwoFactorAuthCode = async (code) => {
   try {
     const response = await axios.post(
       `${serverPath}/api/admin/verifyTwoFactorAuthCode`,
       { code },
       {
         headers: {
           Authorization: `Bearer ${adminToken}`,
         },
       },
     );
     if (response?.data?.code === 200) {
       setDisplayData({});
       setOpen(false);
       setTwoFactorData({
         twoFactorAuthEnabled: response?.data?.isValid,
       });
       toast.success("Login Successful", { toastId: "success-message-2fa-login" });
       localStorage.setItem("ad@#t", adminToken);
       window.location.href = "/dashboard";
     }else{
      toast.error(response?.data?.message || response?.data?.msg);
     }
   } catch (error) {
    console.log("Something went wrong", error);
   }
  };

  const handleOpenLostLine = () => {
    setDisplayData({});
    setOpen(false);
    setLostLine(true);
  };

  const handleCloseRevocation = () => {
    setRevocation(false);
    setRevokeToken("");
    history.push("/");
  };

  const handleCloseLostLine = () => {
    setLostLine(false);
    setDisplayData({});
    setOpen(false);
  };

  const handleMail = async (email) => {
    if (!email.length) return;
    setEmailSending(true);
    try {
      const response = await axios.post(
        `${serverPath}/api/admin/sendReset2FAMail`,
        { email },
      );
      if (response.data.code === 200) {
        toast.success(response.data.message, {
          toastId: "success-message-reset-mail",
        });
        setLostLine(false);
      }else{
        toast.error(response.data.message || response.data.msg, { id: "error-message-reset-mail" });
      }
    } catch (error) {
      console.log("Something went wrong", error);
      toast.error("Something went wrong", { id: "error-message-reset-mail" });
    } finally {
      setEmailSending(false);
    }
  };

  const handleRevocation = async (revocationCode) => {
    try {
      setRevocationLoading(true);
      const response = await axios.post(
        `${serverPath}/api/admin/revocation2FA`,
        { revokeToken, revokeCode: revocationCode },
      );

      if (response.data.code === 200) {
        toast.success(response.data.message, {
          toastId: "success-message-revocation",
        });
        handleCloseRevocation();
      }else{
        toast.error(response.data.message, { id: "error-message-revocation" });
      }
    } catch (error) {
      console.log("Something went wrong", error);
      toast.error("Something went wrong", { id: "error-message-revocation" });
    } finally {
      setRevocationLoading(false);
    }
  };

  const onSubmitHandler = async (data) => {
    try {
      if (Object.keys(errors).length === 0) {
        data.email = data?.email?.toLowerCase();
        const response = await withoutAuth().post("/api/admin/login", data);
        const { token, code, msg } = response.data;
        if (code === 200) {
          if (token) {
            await checkTwoFAEnable(token);
            // localStorage.setItem("ad@#t", token);
            // window.location.href = "/dashboard";
            reset();
          }
        } else {
          toast.error(msg);
        }
      }
    } catch (error) {}
  };
  const clickActive = (event) => {
    document.querySelector(".nav-link").classList.remove("show");
    event.target.classList.add("show");
  };
  return (
    <div>
      <Fragment>
        <Tabs>
          <TabList className="nav nav-tabs tab-coupon login-tab">
            <Tab className="nav-link" onClick={(e) => clickActive(e)}>
              <User />
              Login
            </Tab>
            {/* <Tab className="nav-link" onClick={(e) => clickActive(e)}>
							<Unlock />
							Register
						</Tab> */}
          </TabList>

          <TabPanel className="login-tab-page">
            <Form
              className="form-horizontal auth-form"
              onSubmit={handleSubmit(onSubmitHandler)}>
              <FormGroup>
                <input
                  {...register("email")}
                  type="text"
                  className="form-control"
                  placeholder="Email"
                />
                <p className="text-danger">{errors.email?.message}</p>
              </FormGroup>
              <FormGroup>
                <input
                  {...register("password")}
                  type="password"
                  className="form-control"
                  placeholder="Password"
                />
                <p className="text-danger">{errors.password?.message}</p>
              </FormGroup>
              {/* <div className='form-terms'>
                <div className='custom-control custom-checkbox mr-sm-2'>
                  <Input
                    type='checkbox'
                    className='custom-control-input'
                    id='customControlAutosizing'
                  />
                  <Label className='d-block'>
                    <Input
                      className='checkbox_animated'
                      id='chk-ani2'
                      type='checkbox'
                    />
                    Reminder Me{' '}
                    <span className="pull-right">
											{" "}
											<a href="/#" className="btn btn-default forgot-pass p-0">
												Forget Password
											</a>
										</span>
                  </Label>
                </div>
              </div> */}
              <div className="form-button">
                <Button
                  color="primary"
                  type="submit"
                  // onClick={() => routeChange()}
                >
                  Login
                </Button>
              </div>
              {/* <div className="form-footer">
								<span>Or Login up with social platforms</span>
								<ul className="social">
									<li>
										<a href="/#">
											<i className="icon-facebook"></i>
										</a>
									</li>
									<li>
										<a href="/#">
											<i className="icon-twitter-alt"></i>
										</a>
									</li>
									<li>
										<a href="/#">
											<i className="icon-instagram"></i>
										</a>
									</li>
									<li>
										<a href="/#">
											<i className="icon-pinterest-alt"></i>
										</a>
									</li>
								</ul>
							</div> */}
            </Form>
          </TabPanel>
          <TabPanel>
            <Form className="form-horizontal auth-form">
              <FormGroup>
                <Input
                  required=""
                  name="login[username]"
                  type="email"
                  className="form-control"
                  placeholder="Username"
                  id="exampleInputEmail12"
                />
              </FormGroup>
              <FormGroup>
                <Input
                  required=""
                  name="login[password]"
                  type="password"
                  className="form-control"
                  placeholder="Password"
                />
              </FormGroup>
              <FormGroup>
                <Input
                  required=""
                  name="login[password]"
                  type="password"
                  className="form-control"
                  placeholder="Confirm Password"
                />
              </FormGroup>
              <div className="form-terms">
                <div className="custom-control custom-checkbox mr-sm-2">
                  <Input
                    type="checkbox"
                    className="custom-control-input"
                    id="customControlAutosizing"
                  />
                  <Label className="d-block">
                    <Input
                      className="checkbox_animated"
                      id="chk-ani2"
                      type="checkbox"
                    />
                    I agree all statements in{" "}
                    <span>
                      <a href="/#">Terms &amp; Conditions</a>
                    </span>
                  </Label>
                </div>
              </div>
              {/* <div className='form-button'>
                <Button
                  color='primary'
                  type='submit'
                  onClick={() => routeChange()}>
                  Register
                </Button>
              </div> */}
              {/* <div className="form-footer">
								<span>Or Sign up with social platforms</span>
								<ul className="social">
									<li>
										<a href="/#">
											<i className="icon-facebook"></i>
										</a>
									</li>
									<li>
										<a href="/#">
											<i className="icon-twitter-alt"></i>
										</a>
									</li>
									<li>
										<a href="/#">
											<i className="icon-instagram"></i>
										</a>
									</li>
									<li>
										<a href="/#">
											<i className="icon-pinterest-alt"></i>
										</a>
									</li>
								</ul>
							</div> */}
            </Form>
          </TabPanel>
        </Tabs>
      </Fragment>
      {open ? (
        <Popup2FA
          open={open}
          handleClose={handleClose}
          displayData={displayData}
          twoFactorData={twoFactorData}
          handleClick={verifyTwoFactorAuthCode}
          handleOpenLostLine={handleOpenLostLine}
        />
      ) : lostLine ? (
        <Reset
          open={lostLine}
          handleClose={handleCloseLostLine}
          handleMail={handleMail}
          emailSending={emailSending}
        />
      ) : showRevocation ? (
        <Revocation
          open={showRevocation}
          handleClose={handleCloseRevocation}
          handleRevocation={handleRevocation}
          revocationLoading={revocationLoading}
        />
      ) : null}
    </div>
  );
};

export default withRouter(LoginTabset);
